﻿<ng-template #label><ng-content></ng-content></ng-template>
<span>
  <input type="checkbox" [(ngModel)]="gmtChecked" [disabled]="gmtDisabled" (change)="onChanged()">
  <span *ngIf="!gmtLabelPosition || gmtLabelPosition === 'before'"><ng-container *ngTemplateOutlet="label"></ng-container></span>
  <span class="checkmark {{gmtType}}" [ngClass]="{disabled: gmtDisabled, 'half-state': gmtType === 'tristate' && gmtChecked === null}">
    <span *ngIf="gmtType === 'multiselect'" class="plus-sign"></span>
  </span>
  <span *ngIf="gmtLabelPosition === 'after'" class="pl-5"><ng-container *ngTemplateOutlet="label"></ng-container></span>
</span>
